import React from "react";
import { getValue } from "../../utils";
import { EmptyField } from "./components/FieldShell";
import ArrayField from "./fields/ArrayField";
import {
  BooleanField,
  DropdownField,
  GeolocationField,
  PrimitiveField,
  SignatureField,
} from "./fields/BasicFields";
import { FileField, ImageLinkField } from "./fields/FileFields";
import {
  GenericSubtableField,
  PermitChecklistField,
} from "./fields/SubtableFields";
import { getBaseField, isEmpty, isTrue } from "./utils/valueUtils";

export default function FieldRenderer({ row, column, index }) {
  const label = column.label || column.field || `Field ${index + 1}`;
  const raw = getValue(row, column.field);
  const type = String(column.type || "").toLowerCase();
  const key = `${column.field}-${index}`;

  if (type === "imagelink") {
    return (
      <ImageLinkField
        key={key}
        label={label}
        column={column}
        raw={raw}
      />
    );
  }

  if (type === "signature") {
    return (
      <SignatureField key={key} label={label} column={column} raw={raw} />
    );
  }

  if (type === "dropdown") {
    return (
      <DropdownField key={key} row={row} label={label} column={column} />
    );
  }

  if (type === "file") {
    return <FileField key={key} label={label} column={column} raw={raw} />;
  }

  const baseValue = row?.[getBaseField(column.field)];
  const isArrayField =
    (type === "checkbox" && isTrue(column.array)) ||
    Array.isArray(raw) ||
    Array.isArray(baseValue);

  if (isArrayField) {
    return (
      <ArrayField
        key={key}
        row={row}
        label={label}
        column={column}
        raw={raw}
      />
    );
  }

  if (type === "geolocation") {
    return (
      <GeolocationField key={key} label={label} column={column} raw={raw} />
    );
  }

  if (typeof raw === "boolean") {
    return <BooleanField key={key} label={label} column={column} raw={raw} />;
  }

  if (type === "permitchecklists") {
    return (
      <PermitChecklistField
        key={key}
        row={row}
        label={label}
        column={column}
      />
    );
  }

  if (type === "safetychecks" || type === "substring") {
    return (
      <GenericSubtableField
        key={key}
        row={row}
        label={label}
        column={column}
      />
    );
  }

  if (isEmpty(raw)) {
    return <EmptyField key={key} label={label} column={column} />;
  }

  return <PrimitiveField key={key} label={label} column={column} raw={raw} />;
}
